import React, { Suspense, lazy, useContext } from 'react';
import { SocialContext } from '../contexts/socialContext';
import { ChatStateContext } from '../contexts/chatStateContext';
import { MessageProvider } from '../contexts/messageContext';

const LazyChats = lazy(() => import('./Chats/Chats'));

export function ChatOverlay() {
  const context = useContext(SocialContext);
  const { currentChat } = useContext(ChatStateContext);
  if (!context.me || !currentChat) return null;
  return (
    <Suspense fallback={null}>
      <MessageProvider>
        <LazyChats />
      </MessageProvider>
    </Suspense>
  );
}
